import AvatarScreen from '@/screens/profile-screen/edit/AvatarScreen'

export default function AvatarScreenRoute() {
  return <AvatarScreen />
}

